import React, { useRef, useState } from "react";
import Loader from "../../../components/loader";
import WalletConnect from "../../../components/common/walletConnect/index";
import { PoolType } from "../../poolDetail/balancer/types";
import { Button, Col, Dropdown, DropdownButton, Row } from "react-bootstrap";
import MarginIssueTable from "../../../components/table/MarginIssueTable";
import UiTable from "../../../components/table/Table";
import TextInput from "../../../components/textinput/TextInput";
import VerticallyModal from "../../../components/modal/VerticallyModal";
import UiButton from "../../../components/button";
import {
  MarginIssueManager,
  contractAddress,
} from "@verified-network/verified-sdk";

import { toast } from "react-toastify";
import {
  OneYearAsSeconds,
  SuccessToast,
  ToastOptions,
  networks,
} from "../../../utils/constants";
import DropdownItem from "react-bootstrap/esm/DropdownItem";
import Web3 from "web3";
import BigNumber from "bignumber.js";
import { useGetMarginSecurities } from "../../../context/contractDataLoaderService";
import KYCModal from "../../../components/common/kycModal";
import { useAccount, useConnectorClient } from "wagmi";
import {
  getProvider,
  getProviderNetwork,
  getWeb3,
} from "../../../utils/helpers/networks";
import { useGetSecondarySecurities } from "../../../context/contractDataLoaderService";
import AddIssue from "../createSecondaryIssue/issue";
import AddSecondaryBalance from "../createSecondaryIssue/balance";
import AddOffer from "../createSecondaryIssue/offer";
import { useGlobal } from "../../../context/globalContext";

function ManageIssue(props) {
  const { userAddress } = useGlobal();

  const { data: secondaryProduct, loading } = useGetSecondarySecurities();
  const [showKYCModal, setShowKYCModal] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const modalContent = useRef(null);
  const [modalView, setModalView] = useState(0);
  const [accessToken, setAccessToken] = useState("");

  const [security, setSecurity] = useState("");
  const [issuedSecurityModal, setIssuedSecurityModal] = useState(false);
  const [isManageIssue, setIsManageIssue] = useState(true);

  const [companyName, setCompanyName] = useState("");
  const [isinValue, setIsinValue] = useState("");
  const [currency, setCurrency] = useState("Select Currency");
  const [investorAddress, setInvestorAddress] = useState("");
  const [amount, setAmount] = useState("");
  const [productType, setProductType] = useState("Select type");
  const [productCategory, setProductCategory] = useState("Select category");
  const [intermediary, setIntermediary] = useState({ address: userAddress });

  const handleModalHide = () => {
    setShowModal(false);
    setModalView(0);
  };

  const commonProps = {
    modalView,
    isManageIssue,
    updateModalView: setModalView,
    showModal,
    updateShowModal: setShowModal,
    showKYCModal,
    updateShowKYCModal: setShowKYCModal,

    currency,
    updateCurrency: setCurrency,
    security,
    updateSecurity: setSecurity,
    issuedSecurityModal,
    setIssuedSecurityModal,

    companyName,
    updateCompanyName: setCompanyName,
    isinValue,
    updateIsinValue: setIsinValue,

    intermediary,
    updateIntermediary: setIntermediary,

    investorAddress,
    updateInvestorAddress: setInvestorAddress,
    productType,
    updateProductType: setProductType,
    amount,
    updateAmount: setAmount,
    productCategory,
    updateProductCategory: setProductCategory,

    onModalHide: handleModalHide,
  };

  const headers = [
    { label: "Security", val: "securitySymbol" },
    { label: "Security Category", val: "securityCategory" },
    { label: "Currency", val: "currencySymbol" },
    { label: "Balance", val: "securityBalance" },
    { label: "Call Action", val: "secondaryManageAction" },
  ];

  let message, heading;
  if (modalView === 1) {
    heading = "New Secondary Issue";
    message = <AddIssue {...commonProps} />;
  } else if (modalView === 2) {
    heading = "Add Balance";
    message = <AddSecondaryBalance {...commonProps} />;
  } else if (modalView === 3) {
    heading = "Add Issue";
    message = <AddOffer {...commonProps} />;
  }

  return (
    <>
      {loading ? <Loader /> : null}
      <section className="d-flex flex-column align-items-start px-0 py-4">
        <div className="mb-3 d-flex justify-content-between w-100 align-items-center">
          <div className="w-100">
            <h3 className="text-left">Secondary Products</h3>
          </div>
        </div>
        <div className="pools-table width-100">
          <UiTable
            thead={headers}
            tbodyData={secondaryProduct || []}
            hover
            bordered={false}
            commonProps={commonProps}
            isUpdate
            chainId={props.chainId}
          />
        </div>
      </section>
      <WalletConnect loggedIn={props.loggedIn} />
      <VerticallyModal
        key="connectProvider"
        showModal={showModal}
        modalOnHide={handleModalHide}
        modalSize={"lg"}
        modalHeading={
          <h2>
            <b>{heading}</b>
          </h2>
        }
        withFooter={false}
      >
        {message}
      </VerticallyModal>
      {showKYCModal && (
        <KYCModal
          accessToken={accessToken}
          setshowKYCModal={setShowKYCModal}
          showKYCModal={showKYCModal}
        />
      )}
    </>
  );
}

export default function ManageSecondaryIssues(props) {
  return <ManageIssue {...props} />;
}
